import { email as emailValidator, helpers, required, sameAs } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";

const { locale } = await useLocale("validation");

export default {
  email: {
    required: helpers.withMessage(validationJson.required, required),
    email: helpers.withMessage(validationJson.invalid_email, emailValidator),
  },
  privacy1: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    sameAsRawValue: helpers.withMessage(
      () =>
        locale?.value?.privacy1_required ?? validationJson.privacy1_required,
      sameAs(true),
    ),
  },
  privacy2: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  privacy3: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  privacy4: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  politicallyExposedPerson: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
};
